export const PARTICLE = 0;
export const SLIDESHOW = 1;
export const FULLSCREEN_SLIDESHOW = 2;
export const MULTI_COLUMN = 3;
export const E_COMMERCE = 4;
export const PARALLAX = 5;

export const ASSEMBLER_PARTICLE_TYPES = new Set([
    PARTICLE,
    SLIDESHOW,
    FULLSCREEN_SLIDESHOW,
    MULTI_COLUMN,
    E_COMMERCE,
    PARALLAX,
]);

export const SHOW_NEW_PARTICLE_NOTIFICATION_TIME = 4000;

export const REFRESH_PARTICLE_LIST_TIME = 1000 * 30;
